import type { Reader } from '@/api/client';

/** Отображение ФИО в таблице каталога чтецов: сначала фамилия, затем имя. */
export function readerCatalogTableDisplayName(reader: Pick<Reader, 'name' | 'first_name' | 'last_name'>): string {
  const ln = typeof reader.last_name === 'string' ? reader.last_name.trim() : '';
  const fn = typeof reader.first_name === 'string' ? reader.first_name.trim() : '';
  if (ln || fn) {
    return [ln, fn].filter(Boolean).join(' ');
  }
  return typeof reader.name === 'string' ? reader.name.trim() : '';
}
